<template>
  <transition name="modal">
    <div class="profile-modal" v-show="visible" @click.self="close">
      <div class="modal-container">
        <div class="modal-header">
          <h3>个人中心</h3>
          <i class="el-icon-close" @click="close" />
        </div>
        <div class="modal-body">
          <div class="avatar-section">
            <div class="avatar-wrapper">
              <img v-if="user.avatar" :src="user.avatar" class="avatar" />
              <div v-else class="avatar-text">{{ avatarText }}</div>
            </div>
            <button class="change-avatar-btn" @click="changeAvatar">
              更换头像
            </button>
          </div>

          <div class="info-section">
            <div class="info-item">
              <label>用户名</label>
              <div class="info-content">{{ user.username }}</div>
            </div>
            <div class="info-item">
              <label>手机号码</label>
              <div class="info-content">{{ user.phone || '未绑定' }}</div>
            </div>
            <div class="info-item">
              <label>电子邮箱</label>
              <div class="info-content">{{ user.email || '未绑定' }}</div>
            </div>
            <div class="info-item">
              <label>注册时间</label>
              <div class="info-content">
                {{ user.registerTime }}
              </div>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <el-button class="btn edit-btn" disabled @click="editProfile">编辑资料</el-button>
          <el-button class="btn close-btn" @click="close">关闭</el-button>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: 'ProfileModal',
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    user: {
      type: Object,
      default: () => ({
        username: '用户名',
        avatar: '',
        phone: '',
        email: '',
        registerTime: new Date(),
      }),
    },
  },
  computed: {
    avatarText() {
      return this.user.username ? this.user.username.charAt(0) : '用户';
    },
  },
  methods: {
    close() {
      this.$emit('updateVisible', false);
    },
    changeAvatar() {
      this.$emit('change-avatar');
    },
    editProfile() {
      this.$emit('edit-profile');
    },
  },
};
</script>

<style lang="less" scoped>
.profile-modal {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.modal-container {
  width: 500px;
  max-width: 90%;
  background-color: #fff;
  border-radius: 8px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.2);
  overflow: hidden;
}

.modal-header {
  padding: 15px 20px;
  border-bottom: 1px solid #eee;
  display: flex;
  justify-content: space-between;
  align-items: center;
  .el-icon-close {
    cursor: pointer;
    font-size: 18px;
  }
}
.modal-header h3 {
  margin: 0;
  font-size: 18px;
  color: #333;
}

.close-btn {
  background: none;
  border: none;
  font-size: 24px;
  cursor: pointer;
  color: #999;
  padding: 0;
  line-height: 1;
}

.close-btn:hover {
  color: #666;
}

.modal-body {
  padding: 20px;
}

.avatar-section {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-bottom: 20px;
}

.avatar-wrapper {
  width: 100px;
  height: 100px;
  border-radius: 50%;
  background-color: #f0f0f0;
  margin-bottom: 10px;
  overflow: hidden;
  display: flex;
  justify-content: center;
  align-items: center;
}

.avatar {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.avatar-text {
  font-size: 40px;
  color: #fff;
  background-color: #4a90e2;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.change-avatar-btn {
  background: none;
  border: none;
  color: #4a90e2;
  cursor: pointer;
  font-size: 14px;
  padding: 0;
}

.change-avatar-btn:hover {
  text-decoration: underline;
}

.info-section {
  border-top: 1px solid #eee;
  padding-top: 20px;
}

.info-item {
  display: flex;
  margin-bottom: 15px;
}

.info-item label {
  width: 80px;
  color: #666;
  font-size: 14px;
}

.info-content {
  flex: 1;
  font-size: 14px;
  color: #333;
}

.modal-footer {
  padding: 15px 20px;
  border-top: 1px solid #eee;
  display: flex;
  justify-content: flex-end;
}

.btn {
  padding: 8px 15px;
  border-radius: 4px;
  cursor: pointer;
  font-size: 14px;
  margin-left: 10px;
}

.edit-btn {
  background-color: #4a90e2;
  color: white;
  border: none;
}

.edit-btn:hover {
  background-color: #3a7bc8;
}

.close-btn {
  background-color: #f5f5f5;
  color: #666;
  border: 1px solid #ddd;
}

.close-btn:hover {
  background-color: #eaeaea;
}

/* 过渡动画 */
.modal-enter-active,
.modal-leave-active {
  transition: opacity 0.3s;
}
.modal-enter,
.modal-leave-to {
  opacity: 0;
}

.modal-enter-active .modal-container,
.modal-leave-active .modal-container {
  transition: transform 0.3s;
}
.modal-enter .modal-container,
.modal-leave-to .modal-container {
  transform: translateY(-20px);
}
</style>
